// extracted by mini-css-extract-plugin
module.exports = {"trustedBadge":"trustedBadge_trustedBadge__aSky0","right":"trustedBadge_right__Utnje","description":"trustedBadge_description__0EcHL","images":"trustedBadge_images__IWuFO"};